import axios from "axios";
import { axiosTransformJSON5 } from "@/common/helper";
import { IZuoraFormConfig, ICaptchaConfig, IPendoConfig, IFooterLinksConfig } from "./api/interfaces";
import { captcha, footerLinks, pendo, zuoraForm } from "@/define";

export interface IConfig {
  zuoraForm: IZuoraFormConfig;
  captcha: ICaptchaConfig;
  pendo: IPendoConfig;
  footerLinks: IFooterLinksConfig;
}
const origin = window.location.origin.toLowerCase();

//This Axios call MUST stay as is for now. Removing this Axios call will cause the entire APP to break due to circular dependency issues.
// The config.json file is required to be fetched before the app can be rendered, and this is the only way to achieve that without refactoring the entire app.
//TODO: Refactor the app to remove circular dependencies and allow for a more flexible configuration loading mechanism. This will likely involve restructuring how configuration is accessed throughout the app
export default function (): Promise<IConfig> {
  return axios({
    method: "get",
    url: `${origin}/config/config.json`,
    transformResponse: axiosTransformJSON5,
  }).then(() => {
    return getConfig();
  });
}

function getConfig() {
  const form: IZuoraFormConfig = {
    carboniteId: zuoraForm.carboniteId,
    webrootId: zuoraForm.webrootId,
    carboniteCCMinId: zuoraForm.carboniteCCMinId,
    webrootCCMinId: zuoraForm.webrootCCMinId,
    url: zuoraForm.url,
    submitEnabled: zuoraForm.submitEnabled === "true",
    carbonitePaymentGateway: zuoraForm.carbonitePaymentGateway,
    webrootPaymentGateway: zuoraForm.webrootPaymentGateway,
    style: zuoraForm.style,
    countryBlackList: zuoraForm.countryBlackList,
  };

  const recaptchaConfig: ICaptchaConfig = {
    enforce: captcha.enforce === "true",
    siteKey: captcha.siteKey,
  };

  const pendoConfig: IPendoConfig = {
    apiKey: pendo.apiKey,
    enabled: pendo.enabled === "true",
  };

  const config: IConfig = {
    zuoraForm: form,
    captcha: recaptchaConfig,
    pendo: pendoConfig,
    footerLinks: footerLinks as IFooterLinksConfig,
  };
  return config;
}
